import { setCoremetricsItem } from '@/helpers';

const gaEnabled = () => window.phe.config.isGA4Enabled;

export function setupAnalytics() {
    for (const a of Array.from(document.querySelectorAll('a[sku][data-productid]:not(.tracked-cm)'))) {
        a.addEventListener('click',
            (event) => {
                let el = event.currentTarget;

                setCoremetricsItem(
                    el.getAttribute('data-productid'),
                    el.getAttribute('data-productcategoryid'),
                    el.getAttribute('data-cm-producttype'),
                    el,
                    true,
                    GetQueryStringParams('st'),
                    el.parentElement.getAttribute('data-item-index'));
        });
    }
}
